import { useSyncExternalStore } from 'react';

/**
 * "Instalar o app" (ADR 0041).
 *
 * O navegador avisa que o app e instalavel com `beforeinstallprompt`, uma vez,
 * cedo - normalmente antes de o menu do usuario existir. Por isso o ouvinte e
 * registrado na subida, em `main.tsx`, e o evento fica guardado aqui ate alguem
 * pedir. Navegador sem o evento (Safari, Firefox) nunca mostra o item: nao ha
 * o que oferecer, e o menu nao promete o que nao cumpre.
 */

interface PedidoDeInstalacao extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

let pedido: PedidoDeInstalacao | null = null;
const ouvintes = new Set<() => void>();

function avisar() {
  for (const ouvinte of ouvintes) ouvinte();
}

export function escutarInstalacao(): void {
  window.addEventListener('beforeinstallprompt', (evento) => {
    // Sem isto o Chrome mostra a propria barra, fora da hora e do lugar.
    evento.preventDefault();
    pedido = evento as PedidoDeInstalacao;
    avisar();
  });
  window.addEventListener('appinstalled', () => {
    pedido = null;
    avisar();
  });
}

/** `true` enquanto o navegador aceita instalar agora. */
export function usePodeInstalar(): boolean {
  return useSyncExternalStore(
    (ouvinte) => {
      ouvintes.add(ouvinte);
      return () => ouvintes.delete(ouvinte);
    },
    () => pedido !== null,
    () => false,
  );
}

export async function instalar(): Promise<void> {
  const atual = pedido;
  if (atual === null) return;
  // O evento so pode ser usado uma vez, aceito ou recusado.
  pedido = null;
  avisar();
  await atual.prompt();
  await atual.userChoice;
}
